/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Constants from './Constants';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { store } from '../../configureStore';
import { eventDispatcher } from '../../components/common/Tagging/index';

function* getDataFromApi({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.getData, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DATA_SUCCESS, response: apiResponse.data });
      // yield invokeTagging('cpc-selected_plan');
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `expressCart ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    logger({
      json: true,
      eventType: 'CustomLog',
      message: 'GENERIC_PAGE',
      note: 'from expressCart getDataFromApi sagas',
      messageType: 'ERROR',
      networkError: {
        error,
        response: error.response || null,
        message: error?.message,
        stack: error?.stack,
        subEventType: 'FeErrorS',
      },
    });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
  hideLoader();
}
function* getUpdateCart(data) {
  try {
    // debugger;
    showLoader();
    const apiResponse = yield call(Actions.getUpdateCartAPI, data);
    // debugger;
    if (apiResponse && apiResponse.data && apiResponse.data.statusCode === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.UPDATE_CART, response: apiResponse.data.addOns });
      hideLoader();
    } else {
      // debugger;
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
      // logError('getUpdateCart', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        store.dispatch({ type: Constants.UPDATE_CART_FAIL, response: true });
        eventDispatcher('error', {
          message: apiResponse.data.errors,
          id: apiResponse?.data?.statusCode || null,
        });
      }
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `expressCart ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    if (error && error.response) {
      store.dispatch({ type: Constants.UPDATE_CART_FAIL, response: true });
      store.dispatch({ type: Constants.UPDATE_CART_FAIL_RESPONSE, response: error?.message });
    }
    // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
    logger({
      json: true,
      eventType: 'CustomLog',
      message: 'GENERIC_PAGE',
      note: 'from getUpdateCart sagas',
      messageType: 'ERROR',
      networkError: {
        error,
        response: error.response || null,
        message: error?.message,
        stack: error?.stack,
        subEventType: 'FeErrorS',
      },
    });
    // logError('getUpdateCart', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* partnerCheckAvl(data) {
  try {
    const apiResponsePartnerCheckAvl = yield call(Actions.partnerCheckAvlAPI, data);
    if (apiResponsePartnerCheckAvl && apiResponsePartnerCheckAvl.data && apiResponsePartnerCheckAvl.data.status === 200) {
      yield put({ type: Constants.PARTNER_AVL, response: apiResponsePartnerCheckAvl.data });
      hideLoader();
    } else {
      if (apiResponsePartnerCheckAvl.data.loggerData)
        apiResponsePartnerCheckAvl.data.loggerData.note = `partnerCheckAvlAPI ${apiResponsePartnerCheckAvl?.data?.loggerData.note}`;
      logger(apiResponsePartnerCheckAvl?.data?.loggerData);
      // logError('partnerCheckAvlAPI', FE_API_ERROR);
      hideLoader();
    }
  } catch (errorPartnerCheckAvl) {
    logger({
      json: true,
      eventType: 'CustomLog',
      message: 'GENERIC_PAGE',
      note: 'from partnerCheckAvlAPI sagas',
      messageType: 'ERROR',
      networkError: {
        error: errorPartnerCheckAvl,
        response: errorPartnerCheckAvl.response || null,
        message: errorPartnerCheckAvl?.message,
        stack: errorPartnerCheckAvl?.stack,
        subEventType: 'FeErrorS',
      },
    });
    // logError('partnerCheckAvlAPI', error, FE_API_JS_ERROR);
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* callPushMessage(data) {
  try {
    const apiResponsePushMessage = yield call(Actions.pushMessageApiCall, data);
    if (apiResponsePushMessage && apiResponsePushMessage.data && apiResponsePushMessage.data.status === 200) {
      hideLoader();
    } else {
      if (apiResponsePushMessage.data.loggerData)
        apiResponsePushMessage.data.loggerData.note = `callPushMessage ${apiResponsePushMessage?.data?.loggerData.note}`;
      logger(apiResponsePushMessage?.data?.loggerData);
      // logError('callPushMessage', FE_API_ERROR);
      hideLoader();
    }
  } catch (errorPushMessage) {
    logger({
      json: true,
      eventType: 'CustomLog',
      message: 'GENERIC_PAGE',
      note: 'from callPushMessage sagas',
      messageType: 'ERROR',
      networkError: {
        error: errorPushMessage,
        response: errorPushMessage.response || null,
        message: errorPushMessage?.message,
        stack: errorPushMessage?.stack,
        subEventType: 'FeErrorS',
      },
    });
    // logError('callPushMessage', error, FE_API_JS_ERROR);
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_DATA_FROM_API, getDataFromApi);
  yield takeLatest(Constants.UPDATE_CART, getUpdateCart);
  yield takeLatest(Constants.PARTNER_AVL, partnerCheckAvl);
  yield takeLatest(Constants.PUSH_MESSAGE_CALL, callPushMessage);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
